<template>
  <pdf src="/files/Permissions.pdf" v-for="i in 5" :key="i" :page="i"></pdf>
</template>

<script>
import pdf from "vue3-pdf";
export default {
  components: {
    pdf,
  },
};
</script>

<style></style>
